var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApplicationreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 30.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9189"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8694",
    fill: "none",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7327",
    d: "M15.25 29.75h0a14.5 14.5 0 01-14.5-14.5h0A14.5 14.5 0 0115.25.75h0a14.5 14.5 0 0114.5 14.5h0a14.5 14.5 0 01-14.5 14.5z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Search, Loupe"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6073",
    d: "M6.25 6.25h18v18h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6074",
    d: "M18.035 11.379a4.707 4.707 0 11-6.657 0 4.707 4.707 0 016.657 0",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6075",
    d: "M20.499 20.499l-2.467-2.467",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))))));
}

export default SvgApplicationreview;


//////////////////
// WEBPACK FOOTER
// ./src/icons/application review.svg
// module id = 791
// module chunks = 101